<template>
  <div class=" loginBody">
    <div class="loginAuto">
      <div class="logo">
        <img src="../views/images/dllogo.jpg" v-if="$WebName||$WebGbs">
        <img src="../views/images/dllogogb.jpg" v-if="$WebName&&$WebGbs">
        <img src="../views/images/dllogo1.jpg" v-if="!$WebName">
      </div>
      <div class="loginItem">
        <ul class="loginTab flex">
          <li @click="login_type = 1" :class="{active:login_type == 1}">密码登录</li>
          <li @click="login_type = 0" :class="{active:login_type == 0}">验证码登录</li>
        </ul>
        <!-- 密码登录 -->
        <div class="loginPage" v-if="login_type == 1">
          <ul class="loginList">
            <li>
              <i class="icon">
                <img src="../views/images/icon_01.jpg">
              </i>
              <input class="text" v-model="userName" placeholder="请输入账号/手机号" type="text" @focus="loginerror=''"
                @keydown.enter="index" />
            </li>
            <li>
              <i class="icon">
                <img src="../views/images/icon_02.jpg">
              </i>
              <input name="" type="password" class="text mima_dd" v-if="eyeflag" v-model="password" placeholder="请输入密码"
                @focus="loginerror =''" @keydown.enter="index">
              <input name="" type="text" class="text mima_wz" v-else v-model="password" placeholder="请输入密码"
                @focus="loginerror = ''" @keydown.enter="index">
              <a class="eyes_box " @click="eyeflag = !eyeflag"></a>
            </li>
            <li>
              <div style="display: flex; justify-content: end;">
                <div style="height: 30px;margin-left: 10px;width: 270px;"><span style="margin-left: 0px;" class="error" v-if="loginerror!=''">{{loginerror}}</span></div>
                <label style="width: 70px;padding: 0px;"><input type="checkbox" name="reading" @click="changeagree" v-model="agreementFLAG">记住我</label>
              </div>
              <button class="btn" @click="index()">登录</button>
              <!-- <div class="flex-between">
                <a class="open" href="">新用户注册</a>
                <a class="open" href="">忘记密码？</a>
              </div> -->
            </li>
          </ul>
        </div>
        <!-- 验证码登录 -->
        <div class="loginPage" v-if="login_type ==0">
          <ul class="loginList">
            <li>
              <i class="icon">
                <img src="../views/images/icon_01.jpg">
              </i>
              <input class="text" placeholder="请输入手机号" v-model="phone" type="text" @keydown.enter="index" />
              <span class="error" v-if="phoneerror!=''">{{phoneerror}}</span>
            </li>
            <li>
              <i class="icon">
                <img src="../views/images/icon_03.jpg">
              </i>
              <input class="text" placeholder="请输入验证码" v-model="text1" type="text" @keydown.enter="index" />
              <button class="yanzhengma" v-bind:disable="codeTime!=0"
                @click="sendCode">发送验证码{{codeTime!=0?'('+codeTime+')':''}}</button>
            </li>
            <span class="error" v-if="codeerror!=''">{{codeerror}}</span>
            <li>
              <button style="margin-top: 33px;" class="btn" @click="index()">登录</button>
              <div class="flex-between">
                <a class="open" href="">新用户注册</a>
                <a class="open" href="">忘记密码？</a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="copyright" v-if="$WebName">
      <p>版权所有 © 1998-{{new Date().getFullYear()}} 51优化志愿网 鲁ICP备19022382号-1<br>服务时间：周一至周六 08:30-17:00 节假日不休 统一客服热线：400-150-6806</p>
    </div>
    <div class="copyright"  v-if="!$WebName">
      <p>版权所有 © 1998-{{new Date().getFullYear()}} 志愿导航网 鲁ICP备2021036308号-1<br>服务时间：周一至周六 08:30-17:00 节假日不休 统一客服热线：18562615223'</p>
    </div>
  </div>
</template>

<script>
  import "./css/reset.css"
  import "./css/style.css"
  import "./js/jquery-1.8.3.min.js"
  export default {
    name: "",
    components: {

    },
    data() {
      return {
        userName: '',
        password: '',
        loginName: '',
        phone: '',
        text1: '',
        codeerror: '',
        phoneerror: '',
        loginerror: '',
        login_type: 1,
        eyeflag: true,
        dis: false,
        codeTime: 0,
        agreementFLAG: false,
      }
    },
    mounted() {
      console.log('login');

      let _this = this;
      if (this.$utils.getlocalStorage('agreementFLAG')) {
        this.agreementFLAG = this.$utils.getlocalStorage('agreementFLAG')
      }
      if (this.$utils.getlocalStorage('userDate') != null) {
        _this.userName = _this.$utils.getlocalStorage('userDate').loginName
        _this.password = _this.$utils.getlocalStorage('userDate').loginPwd
      }
      var times = 60;

      function roof() {
        if (times == 0) {
          $('.yanzhengma').text('发送验证码(' + times + 's)');
          $('.yanzhengma').prop('disabled', false);
          $('.yanzhengma').text('发送验证码');
          times = 10;
          return
        }
        $('.yanzhengma').text('重新发送(' + times + 's)');
        times--;

        setTimeout(roof, 1000);
      }
      $('.yanzhengma').on('click', function() {
        $(this).prop('disabled', true);
        roof();
      });
    },
    methods: {
      changeagree() {
        this.agreementFLAG = !this.agreementFLAG
      },
      sendCode() {
        if (!this.$utils.regphone(this.phone)) {
          this.phoneerror = "请输入正确的手机号"
          return;
        }
        if (this.codeTime > 0) {
          this.codeerror = "不能重复获取"
          return;
        } else {
          this.getcode();
          this.codeTime = 60
          let timer = setInterval(() => {
            this.codeTime--;
            if (this.codeTime < 1) {
              clearInterval(timer);
              this.codeTime = 0
            }
          }, 1000)
        }
      },
      index() {
        let _this = this;
        let obj = {}
        if (this.login_type == 1) {
          if (_this.userName == null || _this.userName == '' || _this.password == null || _this.password == '') {
            this.loginerror = "请填写登录信息";
            return;
          }
        } else {
          if (!this.$utils.regphone(this.phone)) {
            this.phoneerror = '请输入正确的手机号'
            return;
          }
          if (_this.text1 == null || _this.text1 == '') {
            this.codeerror = '请输入动态验证码'
            return;
          }
        }
        if (this.login_type == 0) {
          obj = {
            userPhone: this.phone,
            code: this.text1
          }
          _this.agreementFLAG = false;
        } else {
          obj = {
            loginName: _this.userName,
            loginPwd: _this.password,
          }
        }

        this.$user.login(obj).then(function(response) {
          if (response.data != null) {
            _this.$utils.removelocalStorage("userToken");
            localStorage.setItem('userToken', response.data)
            _this.$req.getUserInfo({}).then(function(resp) {
              //删除历史数据
              let userId = '';
              if (_this.$utils.getlocalStorage("userInfo") != null) {
                userId = _this.$utils.getlocalStorage("userInfo").userId
              }
              _this.$utils.removelocalStorage("userZhiYuanBatch")
              _this.$utils.removelocalStorage("memberInfo")
              _this.$utils.removelocalStorage("userInfo")
              _this.$utils.removelocalStorage("scoreInfo")
              _this.$utils.removelocalStorage("userCang")
              _this.$utils.removelocalStorage("userGuan")
              _this.$utils.removelocalStorage("areaInfo")
              _this.$utils.removelocalStorage("TianbaoQueryKey")
              _this.$utils.removelocalStorage('userDate')
              _this.$utils.removelocalStorage('ZhiYuanDanObj')
               _this.$utils.removelocalStorage('disTime')



              if (_this.agreementFLAG) {
                _this.$utils.setlocalStorage('userDate', {
                  loginName: _this.userName,
                  loginPwd: _this.password
                })
              }
              if(resp.data.userScore!=null){
                _this.$utils.setlocalStorage('disTime', resp.data.userScore.disTime)
              }
              _this.$utils.setlocalStorage('agreementFLAG', _this.agreementFLAG)

              _this.$utils.setlocalStorage('userInfo', resp.data.userTable)
              _this.$utils.setlocalStorage('userName',resp.data.userTable.loginName)
              _this.$utils.setlocalStorage('memberInfo', resp.data.memberTable)
              _this.$utils.setlocalStorage('zydNum', resp.data.zydNum)
              localStorage.setItem("userId",resp.data.userTable.userId)
              let cang = {
                major: resp.data.major,
                college: resp.data.college,
                collegescore: resp.data.collegescore,
                majorscore: resp.data.majorscore
              }
              if (resp.data.major == null) {
                cang.major = []
              }
              if (resp.data.college == null) {
                cang.college = []
              }
              if (resp.data.collegescore == null) {
                cang.collegescore = []
              }
              if (resp.data.majorscore == null) {
                cang.majorscore = []
              }
              if (resp.data.job == null) {
                cang.job = []
              }
              _this.$utils.setlocalStorage('userCang', cang)
              if (resp.data.userTable.userProvinces != null && resp.data.userTable.userProvinces != ""
              ) {
                let xuankeArea = _this.$utils.getlocalStorage('xuankeArea')
                let areaId = parseInt(resp.data.userTable.userProvinces)
                if (resp.data.userScore) {
                  areaId = parseInt(resp.data.userScore.scoreArea)
                }
                let area = _this.$utils.getlocalStorage('AREA_OBJ')[areaId]
                if (xuankeArea.xingaokao.indexOf(area) == -1) {
                  _this.$utils.setlocalStorage('tianbaoType', 0) //老高考
                } else if (xuankeArea.xingaokao2.indexOf(area) != -1 || xuankeArea.xingaokao3.indexOf(area) !=
                  -1) {
                  _this.$utils.setlocalStorage('tianbaoType', 2) //专业组
                } else {
                  _this.$utils.setlocalStorage('tianbaoType', 1) //单专业
                }
                _this.$utils.setlocalStorage('areaInfo', {
                  areaId: areaId,
                  areaName: area,
                  areaFullName: _this.$utils.getAreaFullName(areaId)
                })
              }
              if (resp.data.userScore) {
                resp.data.userScore.score += ""
                _this.$utils.setlocalStorage('scoreInfo', resp.data.userScore)
                // _this.$utils.removelocalStorage('NEWSPARENT', response.NEWSPARENT)
              }
              if (!_this.$utils.showflag(resp.data.userTable.userPhone)) {
                _this.$router.push('/grzx_xougaimima')
              } else {

                if(resp.data.userTable.userRole !='3'&&resp.data.userTable.userRole !='2' ){
                 if (!_this.$utils.showflag(resp.data.userTable.userName)) {
                   _this.$router.push('/gerenzhongxin')
                 } else {
                   if (resp.data.userScore) {
                     resp.data.userScore.score += ""
                     _this.$utils.setlocalStorage('scoreInfo', resp.data.userScore)
                     _this.$utils.removelocalStorage('NEWSPARENT', response.NEWSPARENT)
                     _this.$router.push('./home')
                     _this.$utils.getFenshu(_this);
                   } else {
                       _this.$router.push('/grzx_wdfs')
                   }
                 }
                } else {
                  // if (!resp.data.userScore) {
                    _this.$router.push('/grzx_wdxs')
                  // } else {
                    // _this.$router.push('./home')
                  // }
                }

              }
            })
          } else {
            _this.loginerror = response.message
          }
        }).catch(function(error) {
          //这里只会在接口是失败状态返回，不需要去处理错误提示
          console.log(error);
        });
      },
      getcode() {
        let _this = this;
        if (!this.$utils.regphone(this.phone)) {
          _this.phoneerror = '请输入正确的手机号'
          return;
        }
        this.$req.sendphonecodelogin({
          phone: this.phone
        }).then(function(response) {
            _this.$alert(response.message, '温馨提示', {
              confirmButtonText: '确定',
              callback: action => {
                this.$message({
                  type: 'info',
                  message: `action: ${ action }`
                });
              }
            });
        })
      },

      // denglu(){
      // 	this.$router.push('./home')
      // },
    },
    created(){
      let _this = this;
      let NEWSPARENT = this.$utils.getlocalStorage('NEWSPARENT')

      let AREA_LIST_ADMIN = this.$utils.getlocalStorage('AREA_LIST_ADMIN')
      if (NEWSPARENT != null && NEWSPARENT != undefined&&AREA_LIST_ADMIN != null && AREA_LIST_ADMIN != undefined) {
        _this.newsparent = NEWSPARENT;
      } else {
        _this.$http.get(_this.$resourcesUrl + "/data/keyValue.json?time=" + new Date().getTime()).then(function(
          response) {
          _this.$utils.setlocalStorage('AREA_LIST', response.AREA_LIST)
          _this.$utils.setlocalStorage('AREA_LIST_ADMIN', response.AREA_LIST_ADMIN);

		  _this.$utils.setlocalStorage('TISHI', response.TISHI)
          _this.$utils.setlocalStorage('AREA_OBJ', response.AREA_OBJ)
          _this.$utils.setlocalStorage('COLLEGELEVEL', response.COLLEGELEVEL)
          _this.$utils.setlocalStorage('COLLEGESUBJECT', response.COLLEGESUBJECT)
          _this.$utils.setlocalStorage('MAJORPARENTTYPELIST', response.MAJORPARENTTYPELIST)
          _this.$utils.setlocalStorage('MAJORPARENTTYPEOBJ', response.MAJORPARENTTYPEOBJ)
          _this.$utils.setlocalStorage('NEWSPARENT', response.NEWSPARENT)
          _this.$utils.setlocalStorage('MAJORTYPEOBJ', response.MAJORTYPEOBJ)
          _this.$utils.setlocalStorage('NEWSTYPELIST', response.NEWSTYPELIST)
          _this.$utils.setlocalStorage('NEWSTYPEOBJ', response.NEWSTYPEOBJ)
          _this.$utils.setlocalStorage('NEWSAllOBJ', response.NEWSAllOBJ)
          _this.$utils.setlocalStorage('SUBJECTTYPELIST', response.SUBJECTTYPELIST)
          _this.$utils.setlocalStorage('SUBJECTTYPEOBJ', response.SUBJECTTYPEOBJ)
          let xuankeArea = {
            xingaokao: response.xingaokao,
            xingaokao2: response.xingaokao2,
            xingaokao3: response.xingaokao3,
            xingaokao4: response.xingaokao4,
            xingaokao5: response.xingaokao5,
            xingaokao6: response.xingaokao6,
            yishuarea: response.yishuarea,
          }
          _this.$utils.setlocalStorage('xuankeArea', xuankeArea)
        })
      }
    }


  }
</script>

<style scoped>
  .btn:focus {
    outline: 0px auto -webkit-focus-ring-color;
  }
</style>



// WEBPACK FOOTER //
// src/views/login.vue